import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _truncate from "lodash/truncate";
var _excluded = ["text", "url", "type"],
  _excluded2 = ["text", "url", "gridAttributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classnames from 'classnames';
import { Link } from "../../Button/Link/Link";
import { Button } from "../../Button/Button/Button";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Image as ImageComponent } from "../../Image/Image/Image";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import styles from "./SmartPlateSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var smartPlateEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
export var SmartPlateSlice = function SmartPlateSlice(_ref) {
  var icon = _ref.icon,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'eyebrow3',
      variant: 'default'
    } : _ref$eyebrow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 3,
      text: '',
      typog: 'headline3',
      variant: 'default'
    } : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? {
      typog: 'headline5',
      text: '',
      ariaLevel: 4,
      variant: 'default'
    } : _ref$subheading,
    button = _ref.button,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote,
    _ref$scrollTransformB = _ref.scrollTransformBodyScale,
    scrollTransformBodyScale = _ref$scrollTransformB === void 0 ? false : _ref$scrollTransformB,
    plates = _ref.plates;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  useEffect(function () {
    plates && plates.forEach(function (picture) {
      if (picture.plateImage) {
        var img = new Image();
        img.src = picture.plateImage.src;
      }
    });
    // eslint-disable-next-line
  }, []);
  var onItemSelect = function onItemSelect(event, index) {
    event.preventDefault();
    setIndex(index);
  };
  var renderButton = function renderButton(button) {
    var _ref2 = button || {},
      text = _ref2.text,
      url = _ref2.url,
      type = _ref2.type,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      url: url,
      type: type
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderPlatePager = function renderPlatePager() {
    if (!plates) {
      return null;
    }
    return /*#__PURE__*/_jsx("ul", {
      className: styles.mealTypeList,
      children: plates.map(function (plate, i) {
        var selected = index === i;
        return /*#__PURE__*/_jsx(CSSTransition, {
          timeout: 200,
          classNames: "fade",
          children: /*#__PURE__*/_jsx("li", {
            className: classnames(styles.plate, selected ? styles.selectedPlateType : styles.notSelectedPlate),
            children: /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
              onClick: function onClick(e) {
                return onItemSelect(e, i);
              }
            }, plate.plateAttributes), {}, {
              children: [/*#__PURE__*/_jsx(Text, {
                textElement: "div",
                typog: "bodycopy",
                className: styles.plateContent,
                children: plate.plateType
              }), selected && /*#__PURE__*/_jsx(Text, {
                textElement: "div",
                typog: "bodycopySmall",
                className: styles.plateName,
                children: _truncate(plate.plateName, {
                  length: 40
                })
              })]
            }))
          })
        }, i);
      })
    });
  };
  var renderFeaturedPlate = function renderFeaturedPlate() {
    var _plates$index, _plates$index$plateIm, _plates$index2, _plates$index2$plateI, _plates$index3, _plates$index3$plateI;
    return /*#__PURE__*/_jsx(TransitionGroup, {
      className: styles.featuredDishTransition,
      children: /*#__PURE__*/_jsx(CSSTransition, {
        timeout: 200,
        classNames: {
          enter: styles['featured-dish-enter'],
          enterActive: styles['featured-dish-enter-active'],
          exit: styles['featured-dish-exit'],
          exitActive: styles['featured-dish-exit-active'],
          exitDone: styles['featured-dish-exit-done']
        },
        children: /*#__PURE__*/_jsx(ImageComponent, {
          loading: "eager",
          alt: plates ? (_plates$index = plates[index]) === null || _plates$index === void 0 ? void 0 : (_plates$index$plateIm = _plates$index.plateImage) === null || _plates$index$plateIm === void 0 ? void 0 : _plates$index$plateIm.alt : undefined,
          className: classnames(styles.featuredDish, plates && ((_plates$index2 = plates[index]) === null || _plates$index2 === void 0 ? void 0 : (_plates$index2$plateI = _plates$index2.plateImage) === null || _plates$index2$plateI === void 0 ? void 0 : _plates$index2$plateI.className)),
          src: plates && ((_plates$index3 = plates[index]) === null || _plates$index3 === void 0 ? void 0 : (_plates$index3$plateI = _plates$index3.plateImage) === null || _plates$index3$plateI === void 0 ? void 0 : _plates$index3$plateI.src) || '',
          width: "424",
          height: "424",
          transformations: {
            image1x: {
              width: 424
            },
            image2x: {
              width: 848
            }
          }
        })
      }, plates && plates[index].plateName)
    });
  };
  var renderGridContent = function renderGridContent(section) {
    var _plates$index$grid, _plates$index4, _plates$index4$grid, _plates$index$grid2;
    var list = plates && ((_plates$index$grid = plates[index].grid) === null || _plates$index$grid === void 0 ? void 0 : _plates$index$grid.dishes.map(function (dish, i) {
      var _dish$dishImage, _dish$dishImage2;
      return /*#__PURE__*/_jsx(CSSTransition, {
        timeout: 200,
        classNames: {
          enter: styles['dish-grid-enter'],
          enterActive: styles['dish-grid-enter-active'],
          exit: styles['dish-grid-exit']
        },
        children: /*#__PURE__*/_jsx("li", {
          className: classnames(styles.dishItem, styles[section]),
          children: /*#__PURE__*/_jsxs(Link, _objectSpread(_objectSpread({
            newWindow: false,
            url: dish.dishURL
          }, dish.dishAttributes), {}, {
            children: [/*#__PURE__*/_jsx("div", {
              className: classnames(styles.imageWrapper, styles[section]),
              children: /*#__PURE__*/_jsx(ImageComponent, {
                alt: ((_dish$dishImage = dish.dishImage) === null || _dish$dishImage === void 0 ? void 0 : _dish$dishImage.alt) || '',
                src: ((_dish$dishImage2 = dish.dishImage) === null || _dish$dishImage2 === void 0 ? void 0 : _dish$dishImage2.src) || '',
                loading: "eager",
                width: "180",
                height: "180",
                transformations: {
                  image1x: {
                    width: 180
                  },
                  image2x: {
                    width: 360
                  }
                }
              })
            }), /*#__PURE__*/_jsx(Text, {
              textElement: "span",
              typog: "bodycopyLarge",
              className: styles.dishName,
              children: _truncate(dish.dishName, {
                length: 40
              })
            })]
          }))
        })
      }, i);
    }));

    // Add more link to end of grid
    var _ref3 = plates && ((_plates$index4 = plates[index]) === null || _plates$index4 === void 0 ? void 0 : (_plates$index4$grid = _plates$index4.grid) === null || _plates$index4$grid === void 0 ? void 0 : _plates$index4$grid.cta) || {},
      text = _ref3.text,
      url = _ref3.url,
      gridAttributes = _ref3.gridAttributes,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);
    text && url && (list === null || list === void 0 ? void 0 : list.push( /*#__PURE__*/_jsx(CSSTransition, {
      timeout: 500,
      classNames: {
        enter: styles['dish-grid-enter'],
        enterActive: styles['dish-grid-enter-active'],
        exit: styles['dish-grid-exit']
      },
      children: /*#__PURE__*/_jsx("li", {
        className: classnames(styles.dishItem, styles.moreLink, styles[section]),
        children: /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread(_objectSpread({
          newWindow: false,
          url: url
        }, gridAttributes), otherProps), {}, {
          children: /*#__PURE__*/_jsx(Text, {
            className: styles.gridLink,
            textElement: "div",
            typog: "bodycopyLarge",
            children: text
          })
        }))
      })
    }, "link")));
    return /*#__PURE__*/_jsx("div", {
      className: styles["grid-wrapper-".concat(section)],
      children: /*#__PURE__*/_jsxs("div", {
        className: styles["grid-".concat(section)],
        children: [/*#__PURE__*/_jsx(Text, {
          textElement: "span",
          typog: "headline5",
          className: classnames(styles.gridTitle, styles[section]),
          children: plates && ((_plates$index$grid2 = plates[index].grid) === null || _plates$index$grid2 === void 0 ? void 0 : _plates$index$grid2.headline)
        }), /*#__PURE__*/_jsx(TransitionGroup, {
          component: "ul",
          className: styles.dishList,
          children: list
        })]
      })
    });
  };
  var renderSubheading = function renderSubheading() {
    var subheadingComponent = /*#__PURE__*/_jsx("div", {
      className: classnames(styles.subheading),
      children: /*#__PURE__*/_jsx(HeadingText, {
        align: "center",
        typog: subheading.typog,
        ariaLevel: subheading.ariaLevel,
        variant: subheading.variant,
        children: subheading.text
      })
    });
    var scrollTransform = {
      startScrollPercent: 0,
      endScrollPercent: 0.5,
      transforms: [{
        transformFunction: 'scaleX',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }, {
        transformFunction: 'scaleY',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }]
    };
    return scrollTransformBodyScale ? /*#__PURE__*/_jsx(ScrollTransform, _objectSpread(_objectSpread({}, scrollTransform), {}, {
      children: subheadingComponent
    })) : subheadingComponent;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.smartPlateSlice,
    children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
      className: classnames(styles.icon),
      children: /*#__PURE__*/_jsx(ImageComponent, {
        alt: icon.alt,
        src: icon.image1x,
        width: icon.width || undefined,
        height: icon.height || undefined,
        transformations: {
          image1x: {
            width: parseInt((icon === null || icon === void 0 ? void 0 : icon.width) || '', 10) || undefined
          },
          image2x: {
            width: parseInt((icon === null || icon === void 0 ? void 0 : icon.width) || '', 10) * 2 || undefined
          }
        },
        forceTwoXInSrc: true
      })
    }), ((heading === null || heading === void 0 ? void 0 : heading.text) || (subheading === null || subheading === void 0 ? void 0 : subheading.text) || (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text)) && /*#__PURE__*/_jsxs("div", {
      className: styles.introWrapper,
      children: [eyebrow && eyebrow.text !== '' && /*#__PURE__*/_jsx(Text, {
        className: styles.eyebrow,
        typog: eyebrow.typog,
        variant: eyebrow.variant,
        children: eyebrow.text
      }), (heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_jsx("div", {
        className: styles.heading,
        children: /*#__PURE__*/_jsx(HeadingText, {
          align: "center",
          typog: heading.typog,
          ariaLevel: heading.ariaLevel,
          variant: heading.variant,
          children: heading.text
        })
      }), (subheading === null || subheading === void 0 ? void 0 : subheading.text) && renderSubheading()]
    }), (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/_jsx("div", {
      className: styles.buttonWrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: classnames(styles.cta),
        "data-e2e-name": "smart_plate_cta",
        children: renderButton(button)
      })
    }), /*#__PURE__*/_jsx(Container, {
      className: styles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [renderPlatePager(), renderFeaturedPlate(), /*#__PURE__*/_jsxs(Breakpoint, {
          breakpoint: "large",
          children: [/*#__PURE__*/_jsx("span", {}), renderGridContent('sidebar')]
        })]
      })
    }), /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: "large",
      children: [renderGridContent('footer'), /*#__PURE__*/_jsx("span", {})]
    }), footnote && /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.footnote,
        children: /*#__PURE__*/_jsx(Text, {
          className: styles.text,
          typog: "bodycopySmall",
          "data-e2e-name": "carousel_footnote_text",
          children: footnote
        })
      })
    })]
  });
};